export default "__VITE_ASSET__BVsd6U2S__"